import { toggleIsLoading } from './loading'
import messageActions from './message'
import campaignConstants from '../constants/campaign';
import campaignService from '../services/campaign';
import modalActions from './modal';
import promotionService from '../services/promotion';

const campaignCreate = (detail) => ({ type: campaignConstants.CREATE_CAMPAIGN, detail })
const campaignList = (data) => ({ type: campaignConstants.LIST_CAMPAIGN, data })
const campaignRetrieve = (detail) => ({ type: campaignConstants.RETRIEVE_CAMPAIGN, detail })
const campaignUpdate = (detail) => ({ type: campaignConstants.UPDATE_CAMPAIGN, detail })
const campaignDestroy = (campaignApiKey) => ({ type: campaignConstants.DESTROY_CAMPAIGN, apikey: campaignApiKey })
const campaignClear = () => ({ type: campaignConstants.CLEAR_CAMPAIGN });
const campaignManualQueries = (queries) => ({type: campaignConstants.RECEIVE_MANUAL_QUERIES, queries})

const campaignActions = {}

campaignActions.clearCampaign = () => {
  return (dispatch) => {
    dispatch(campaignClear())
  }
}

campaignActions.updateCampaignList = (data) => {
  return (dispatch) => {
    dispatch(campaignList(data))
  }
}

campaignActions.list = (vendorApiKey, locationApiKey) => {
  return (dispatch) => {
    dispatch(toggleIsLoading(true));
    campaignService.list(vendorApiKey, locationApiKey)
    .then((response) => {
      dispatch(campaignList(response));
      dispatch(toggleIsLoading(false));
    })
    .catch((err) => {
      dispatch(toggleIsLoading(false));
      dispatch(messageActions.setErrorMessage(err.message));
    })
  }
}

campaignActions.retrieve = (vendorApiKey, locationApiKey, campaignApiKey) => {
  return (dispatch) => {
    dispatch(toggleIsLoading(true));
    campaignService.retrieve(vendorApiKey, locationApiKey, campaignApiKey)
    .then((response) => {
      dispatch(campaignRetrieve(response));
      dispatch(toggleIsLoading(false));
    })
    .catch((err) => {
      dispatch(toggleIsLoading(false));
      dispatch(messageActions.setErrorMessage(err.message));
    })
  }
}

campaignActions.create = (campaignBody, promotionBody, vendorApiKey, locationApiKey) => {
  return (dispatch) => {
    dispatch(toggleIsLoading(true));
    promotionService.create(promotionBody, vendorApiKey, locationApiKey)
    .then((res) => {
      campaignBody.promotion_apikey = res.apikey;
      campaignService.create(campaignBody, vendorApiKey, locationApiKey)
      .then((response) => {
        dispatch(modalActions.modalToggle(false));
        dispatch(campaignCreate(response));
        dispatch(toggleIsLoading(false));
        dispatch(campaignActions.list(vendorApiKey, locationApiKey));
      })
      .catch((err) => {
        dispatch(toggleIsLoading(false));
        dispatch(messageActions.setErrorMessage(err.message));
      })
    }).catch((error) => {
      dispatch(toggleIsLoading(false));
      dispatch(messageActions.setErrorMessage(err.message));
    })
  }
}

campaignActions.createWithoutPromo = (campaignBody, vendorApiKey, locationApiKey) => {
  return (dispatch) => {
    dispatch(toggleIsLoading(true));
      campaignService.create(campaignBody, vendorApiKey, locationApiKey)
      .then((response) => {
        dispatch(modalActions.modalToggle(false));
        dispatch(campaignCreate(response));
        dispatch(toggleIsLoading(false));
        dispatch(campaignActions.list(vendorApiKey, locationApiKey));
      })
      .catch((err) => {
        dispatch(toggleIsLoading(false));
        dispatch(messageActions.setErrorMessage(err.message));
      })
  }
}

campaignActions.update = (campaignBody, promotionBody, vendorApiKey, locationApiKey, campaignApiKey, promotionApiKey) => {
  return (dispatch) => {
    dispatch(toggleIsLoading(true));
    promotionService.update(promotionBody, vendorApiKey, locationApiKey, promotionApiKey)
    .then((res) => {
      campaignService.update(campaignBody, vendorApiKey, locationApiKey, campaignApiKey)
      .then((response) => {
        dispatch(modalActions.modalToggle(false));
        dispatch(campaignUpdate(response));
        dispatch(toggleIsLoading(false));
        dispatch(campaignActions.list(vendorApiKey, locationApiKey));
      })
      .catch((err) => {
        dispatch(toggleIsLoading(false));
        dispatch(messageActions.setErrorMessage(err.message));
      })
    }).catch((error) => {
      dispatch(toggleIsLoading(false));
      dispatch(messageActions.setErrorMessage(err.message));
    })
  }
}

campaignActions.updateWithoutPromo = (campaignBody, vendorApiKey, locationApiKey, campaignApiKey, promotionApiKey) => {
  return (dispatch) => {
    dispatch(toggleIsLoading(true));
    campaignService.update(campaignBody, vendorApiKey, locationApiKey, campaignApiKey)
    .then((response) => {
      dispatch(modalActions.modalToggle(false));
      dispatch(campaignUpdate(response));
      dispatch(toggleIsLoading(false));
      dispatch(campaignActions.list(vendorApiKey, locationApiKey));
    })
    .catch((err) => {
      dispatch(toggleIsLoading(false));
      dispatch(messageActions.setErrorMessage(err.message));
    })
  }
}

campaignActions.destroy = (locationApiKey, vendorApiKey, campaignApiKey) => {
  return (dispatch) => {
    dispatch(toggleIsLoading(true));
   return campaignService.destroy(locationApiKey, vendorApiKey, campaignApiKey)
    .then((response) => {
      dispatch(messageActions.setSuccessMessage('The campaign was successfully archived.'));
      dispatch(campaignDestroy(campaignApiKey));
      dispatch(toggleIsLoading(false));
      return response;
    })
    .catch((err) => {
      dispatch(toggleIsLoading(false));
      dispatch(messageActions.setErrorMessage(err.message));
      return err;
    })
  }
}

campaignActions.listManualQueries = () => {
  return async (dispatch) => {
    dispatch(toggleIsLoading(true));

    try {
      const manualQueriesResponse = await campaignService.listManualQueries();
      dispatch(campaignManualQueries(manualQueriesResponse));
      dispatch(toggleIsLoading(false));
      return manualQueriesResponse;
    } catch (error) {
      dispatch(toggleIsLoading(false));
      dispatch(messageActions.setErrorMessage(error.message));
      return error;
    }
  }
}

export default campaignActions;



/** WEBPACK FOOTER **
 ** ./src/actions/campaign.js
 **/